import React from 'react'

const PerPageBlock = (props) => {
    const {perPage,setPerPage} = props

    
    return (
        <>
            <div className='d-none d-md-block text-end m-2'>
                <label className='me-1'>Per Page</label>
                <select value={perPage} onChange={(e) => setPerPage(e.target.value)} >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>

            </div>
        </>
    )
}

export default PerPageBlock
